import React from "react";

import FormForgotPassword from "../components/formForgotPassword";
import OnBoardingLayout from "../components/on-boarding-layout";

export default function ForgotPassword() {
  return <OnBoardingLayout screen={<FormForgotPassword />} />;
}
